import {Component, HostBinding, Inject, Injector, OnInit, ViewEncapsulation} from '@angular/core';
import {BaseComponent} from '../../../base.component';
import {DIALOG_DATA, DialogRef} from '@angular/cdk/dialog';
import {animationSlideInOut} from '../../../../util/animation/animation.slideInOut';
import {SnackBarUtil} from '../../../../util/snack.bar.util';
import {ChooserOptions} from './options/chooser.options';
import {DataResponse} from '../../../../network/service/data.response';
import {EditAddressesComponent} from '../edit-addresses/edit-addresses.component';

@Component({
  selector: 'app-chooser',
  standalone: false,
  templateUrl: './chooser.component.html',
  styleUrl: './chooser.component.scss',
  animations: [animationSlideInOut],
  encapsulation: ViewEncapsulation.None
})
export class ChooserComponent extends BaseComponent implements OnInit {
  chooserOptions = new ChooserOptions();
  @HostBinding('@slideInOut') animationState = 'open';
  list: any = [];
  title: any;

  constructor(injector: Injector, public dialogRef: DialogRef<ChooserComponent>, @Inject(DIALOG_DATA) public data: any) {
    super(injector);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    switch (this.data.chooserType) {
      case 'USER_ADDRESS':
        this.title = 'AddressSelect';
        break;
      case 'SPACE':
        this.title = 'SelectSpace';
        break;
    }
  }

  override loadOnline() {
    super.loadOnline();
    switch (this.data.chooserType) {
      case 'USER_ADDRESS':
        let filter = {};
        if (this.data?.DeliveryMethod) {
          filter = {
            Filter: {
              Values: [{
                Field: 'DeliveryMethodId',
                Type: 'EQ',
                Value: this.data.DeliveryMethod.DeliveryMethodId
              },
                this.data.UserId ? {
                  Field: 'UserId',
                  Type: 'EQ',
                  Value: this.data.UserId
                } : {}]
            },
            Order: {
              Field: 'Title',
              Type: 'ASC'
            }
          };
        }
        this.serviceApi.getUserAddresses(0, 0, '', 'ALL', filter).subscribe((res: DataResponse<any>) => {
          if (res.success) {
            this.list = res.data;
            if (this.data?.UserAddress) {
              this.data.UserAddress = this.list.find((userAddress: any) => userAddress.UserAddressId === this.data.UserAddress.UserAddressId);
            }
          } else {
            SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
          }
        });
        break;
      case 'SPACE':
        this.serviceApi.getSpaces(0, 0, '', 'ALL', undefined, {
          Filter: {
            Values: [{
              Field: 'Type',
              Type: 'EQ',
              Value: 'TABLE'
            }]
          },
        }).subscribe((res: DataResponse<any>) => {
          if (res.success) {
            this.list = res.data;
            if (this.data?.Space) {
              this.data.Space = this.list.find((space: any) => space.SpaceId === this.data.Space.SpaceId);
            }
          } else {
            SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
          }
        });
        break;
    }
  }

  onChange(item: any) {
    switch (this.data.chooserType) {
      case 'USER_ADDRESS':
        this.data.UserAddress = item;
        break;
      case 'SPACE':
        this.data.Space = item;
        break;
    }
  }

  noAction(isCloseButton: boolean = false) {
    this.animationState = 'closed';
    setTimeout(() => {
      this.dialogRef.close();
      if (isCloseButton) {
        this.chooserOptions.onChoose(undefined);
      }
    }, 500);
  }

  onChooseClicked() {
    switch (this.data.chooserType) {
      case 'USER_ADDRESS':
        if (this.data?.UserAddress) {
          this.chooserOptions.onChoose(this.data.UserAddress);
          this.noAction(false);
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant('SelectOneOfAddress'), false);
        }
        break;
      case 'SPACE':
        if (this.data?.Space) {
          this.chooserOptions.onChoose(this.data.Space);
          this.noAction(false);
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant('SelectOneOfSpace'), false);
        }
        break;
    }
  }

  onAddressClicked(editMode: boolean) {
    this.dialogRef.close();
    this.chooserOptions.onChoose(undefined);
    this.matDialog.open(EditAddressesComponent, {
      width: '1284px',
      height: '60%',
      data: editMode ? this.data.UserAddress : {
        UserId: this.data.UserId
      }
    });
  }
}
